import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import PropTypes from "prop-types"
import { Modal, Header, Container, Button, Icon } from "semantic-ui-react"
import FileUploadButton from "./FileUploadButton"
import FileDownloadButton from "./FileDownloadButton"
import LoadingError from "../../components/shared/LoadingError"

import withWebSocketConnection from "./withWebSocketConnection"
import { withTranslation } from "react-i18next"
import { isFleetMaintenanceHubCanada } from "../../helpers/affiliationHelpers"
import { EN_LOCALE } from "../../constants/users"
import openBookIcon from "../../assets/images/open_book_Icon.svg"
import { ERROR, SUCCESS } from "../../constants/notification"
import BulkUploadFormatingHelp from "./BulkUploadFormatingHelp"

class BulkUploadModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...this.defaultState()
    }
  }

  static propTypes = {
    saga: PropTypes.string.isRequired,
    loadAllVehicles: PropTypes.func.isRequired
  }

  defaultState = () => {
    return {
      file: null,
      fileObject: null,
      open: false,
      alertMessage: this.props.t("readyForUploadLabel"),
      alertType: "default",
      disableSubmit: false,
      awaitingUploadCompletion: false,
      activeIndex: -1
    }
  }

  open = () => this.setState({ open: true, alertMessage: this.props.t("readyForUploadLabel") })

  close = () => {
    this.setState(!this.state.awaitingUploadCompletion ? this.defaultState() : { open: false })
    this.props.loadAllVehicles && this.props.loadAllVehicles()
  }

  onSubmitSuccess(data) {
    this.setState({
      awaitingUploadCompletion: false,
      alertMessage: data.alertMessage,
      alertType: data.alertType,
      isSubmitting: false,
      submitted: true,
      disableSubmit: true
    })
  }

  onSubmitFailure(data) {
    this.setState({
      awaitingUploadCompletion: false,
      alertMessage: data.error,
      alertType: data.alertType,
      isSubmitting: false,
      submitted: true
    })
  }

  afterSubmit = (status, data) => {
    if (status === "success") {
      this.onSubmitSuccess(data)
    } else {
      this.onSubmitFailure(data)
    }
  }

  handleSave = async () => {
    this.setState({ loading: true })
    this.setState({ awaitingUploadCompletion: true })

    let afterRequestData = await this.props.dispatch({
      type: "VEHICLE_BULK_UPSERT_SAGA",
      payload: { file: this.state.file, t: this.props.t },
      callback: this.afterSubmit
    })
  }

  onChangeFile = (e) => {
    var reader = new FileReader()

    const files = e.target.files
    const file = files ? files[0] : null

    reader.readAsDataURL(file)

    reader.onload = () => {
      this.setState({ file: reader.result, fileObject: file })
    }
  }

  onDataReceived = (uploaderRecordData) => {
    const { t } = this.props
    const map = {
      completed: { msg: t("uploadCompletedLabel"), alertType: "success" },
      completed_with_errors: {
        msg: t("uploadCompletedErrorsLabels"),
        alertType: "error"
      },
      errored: {
        msg: t("uploadCompletedErrorsLabels"),
        alertType: "error"
      }
    }

    this.setState({
      awaitingUploadCompletion: false,
      alertMessage: `${map[uploaderRecordData].msg}. Check your email for a report`,
      alertType: map[uploaderRecordData].alertType
    })
  }

  handleDelete = () => {
    this.setState({
      file: null,
      fileObject: null,
      alertMessage: "",
      alertType: "",
      submitted: false
    })
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { open, activeIndex, alertMessage, fileObject, alertType, awaitingUploadCompletion } =
      this.state
    const { isLoading, isLoadingError, children, t } = this.props
    const { language } = this.props.i18n

    return (
      <React.Fragment>
        <LoadingError visible={!isLoading && isLoadingError} />

        <Modal
          size="tiny"
          trigger={children}
          closeIcon
          open={open}
          onOpen={this.open}
          onClose={this.close}
        >
          {alertType == SUCCESS ? (
            <Modal.Content className="bulk-upload-success">
              <Modal.Description>
                <Icon name="check circle" size="40"></Icon>
                <p className="success-header">{t("uploadSuccessfully")}</p>
                <p>{t("startBooking")}</p>
                <Button fluid htmlFor={this.id} content={t("gotIt")} onClick={this.close} />
              </Modal.Description>
            </Modal.Content>
          ) : (
            <Modal.Content className="bulk-upload">
              <Header size="large" className="upload-header">
                {t("bulkUploadVehiclesLabel")}
              </Header>
              <Modal.Description>
                <Container centered className="upload-desc">
                  <label>{t("uploadSteps")}</label>
                  <p>{t("downloadVehiclesTemplateLabel")}</p>
                  <p>{t("inputVehicleInformationLabel")}</p>
                  <p>{t("vehicleLineLabel")}</p>
                  <p>{t("vehiclesUploadTemplate")}</p>
                </Container>
                <div className="button-div">
                  <FileDownloadButton
                    content={t("downloadTemplateLabel")}
                    downloadLink={
                      isFleetMaintenanceHubCanada() && language == EN_LOCALE
                        ? "https://fleetmaintenancehubca.com/vehicle_upload_template_en_example.csv"
                        : t("downloadLink")
                    }
                  />
                  <BulkUploadFormatingHelp />
                </div>
                {fileObject ? (
                  <div
                    className={
                      alertType == ERROR ? "uploaded-file uploaded-failed" : "uploaded-file"
                    }
                  >
                    <div className="file-info">
                      <Icon className="file-icon" name="file alternate outline"></Icon>
                      <div>
                        <p className="file-name">{fileObject.name}</p>
                        {alertType != ERROR && <p>{fileObject.size / 1000} KB</p>}
                        {alertType == ERROR && <p>{alertMessage}</p>}
                        {alertType == ERROR && (
                          <a className="link" onClick={this.handleSave}>
                            Try Again
                          </a>
                        )}
                      </div>
                    </div>
                    <Button icon onClick={this.handleDelete} className="delete-btn">
                      <Icon name="trash alternate outline"></Icon>
                    </Button>
                  </div>
                ) : (
                  <FileUploadButton
                    content={t("uploadVehiclesCSVLabel")}
                    onChangeFile={this.onChangeFile}
                  />
                )}
                <Button
                  disabled={!fileObject || awaitingUploadCompletion}
                  fluid
                  htmlFor={this.id}
                  onClick={this.handleSave}
                  //className={awaitingUploadCompletion ? "button-loading" : ""}
                >
                  {t("submitFile")}
                  {awaitingUploadCompletion && <span className="ios-spinner" />}
                </Button>
              </Modal.Description>
            </Modal.Content>
          )}
        </Modal>
      </React.Fragment>
    )
  }
} // class BulkUploadModal

const mapStateToProps = (state) => {}

export default connect(mapStateToProps)(
  withRouter(
    withTranslation("vehicle")(
      withWebSocketConnection(BulkUploadModal, "VehicleBulkUpsertionChannel")
    )
  )
)
